import { ReactConfig } from './configApi';

let intelligentServicesApiUrl = '';
let intelligentServicesCompaniesApiUrl = '';
let externalAuthApiUrl = '';
let appEnvironment = '';
let bankIdTestIndex: string;

export const setIntelligentServicesConfig = (reactConfig: ReactConfig) => {
  if (!reactConfig) {
    return;
  }
  intelligentServicesApiUrl = reactConfig.intelligentServicesApiUrl ?? '';
  intelligentServicesCompaniesApiUrl =
    reactConfig.intelligentServicesCompaniesApiUrl ?? '';
  externalAuthApiUrl = reactConfig.intelligentServicesAuthApiUrl ?? '';
  appEnvironment = reactConfig.appEnvironment ?? '';
  bankIdTestIndex = reactConfig.bankIdTestIndex;
};

export const intelligentServicesApiConfig = {
  get baseUrl() {
    return intelligentServicesApiUrl;
  },
};

export const intelligentServicesCompaniesApiConfig = {
  get baseUrl() {
    return intelligentServicesCompaniesApiUrl;
  },
};

export const externalAuthApiConfig = {
  get baseUrl() {
    return externalAuthApiUrl;
  },
};

export const appEnvironmentConfig = () => {
  return appEnvironment;
};

export const bankIdTestIndexConfig = () => {
  return bankIdTestIndex;
};
